"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceDescConfig = exports.PartialServiceDesc = exports.ServiceDesc = void 0;
var IncomingWebhook_1 = require("./IncomingWebhook");
var Rule_1 = require("./Rule");
var json2typescript_1 = require("json2typescript");
var ServiceDesc = (function () {
    function ServiceDesc(partial) {
        this.id = undefined;
        this.name = '';
        this.type = '';
        this.config = undefined;
        this.secretConfig = undefined;
        this.rules = undefined;
        this.incomingWebhooks = undefined;
        this.version = undefined;
        this.lastModified = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String, true),
        __metadata("design:type", String)
    ], ServiceDesc.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], ServiceDesc.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", Object)
    ], ServiceDesc.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], ServiceDesc.prototype, "config", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('secret_config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], ServiceDesc.prototype, "secretConfig", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('rules', Rule_1.RulesConverter, true),
        __metadata("design:type", Array)
    ], ServiceDesc.prototype, "rules", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('incoming_webhooks', [IncomingWebhook_1.IncomingWebhook], true),
        __metadata("design:type", Array)
    ], ServiceDesc.prototype, "incomingWebhooks", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('version', Number, true),
        __metadata("design:type", Number)
    ], ServiceDesc.prototype, "version", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified', Number, true),
        __metadata("design:type", Number)
    ], ServiceDesc.prototype, "lastModified", void 0);
    ServiceDesc = __decorate([
        (0, json2typescript_1.JsonObject)('ServiceDesc'),
        __metadata("design:paramtypes", [Object])
    ], ServiceDesc);
    return ServiceDesc;
}());
exports.ServiceDesc = ServiceDesc;
var PartialServiceDesc = (function () {
    function PartialServiceDesc(partial) {
        this.id = '';
        this.name = '';
        this.type = '';
        this.version = undefined;
        this.lastModified = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialServiceDesc.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], PartialServiceDesc.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", Object)
    ], PartialServiceDesc.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('version', Number, true),
        __metadata("design:type", Number)
    ], PartialServiceDesc.prototype, "version", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified', Number, true),
        __metadata("design:type", Number)
    ], PartialServiceDesc.prototype, "lastModified", void 0);
    PartialServiceDesc = __decorate([
        (0, json2typescript_1.JsonObject)('PartialServiceDesc'),
        __metadata("design:paramtypes", [Object])
    ], PartialServiceDesc);
    return PartialServiceDesc;
}());
exports.PartialServiceDesc = PartialServiceDesc;
var ServiceDescConfig = (function () {
    function ServiceDescConfig(partial) {
        this.config = undefined;
        this.secretConfig = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], ServiceDescConfig.prototype, "config", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('secret_config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], ServiceDescConfig.prototype, "secretConfig", void 0);
    ServiceDescConfig = __decorate([
        (0, json2typescript_1.JsonObject)('ServiceDescConfig'),
        __metadata("design:paramtypes", [Object])
    ], ServiceDescConfig);
    return ServiceDescConfig;
}());
exports.ServiceDescConfig = ServiceDescConfig;
//# sourceMappingURL=Service.js.map